import { render } from "./ServiceSupport.vue?vue&type=template&id=7a3700b4&scoped=true"
import script from "./ServiceSupport.vue?vue&type=script&lang=js"
export * from "./ServiceSupport.vue?vue&type=script&lang=js"

import "./ServiceSupport.vue?vue&type=style&index=0&id=7a3700b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a3700b4"]])

export default __exports__